import React from 'react';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import { bool } from 'prop-types';
import useStyles from './CreateUserButton.styles';

const CreateUserButton = ({ isDisabled }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.buttonContainer}>
      <Button
        disabled={isDisabled}
        data-testid="createUserSubmitButton"
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        className={classes.button}
      >
        <FormattedMessage id="earlyAccess.createUser.button.submit" />
      </Button>
    </div>
  );
};

CreateUserButton.propTypes = {
  isDisabled: bool.isRequired,
};

export default CreateUserButton;
